var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _vm.sessionInfo
        ? _c(
            "div",
            { staticClass: "page-header" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("会话ID：")]),
                      _c("span", [_vm._v(_vm._s(_vm.sessionInfo.sessionId))]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("会话标题：")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.sessionInfo.sessionTitle || "无标题")
                        ),
                      ]),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("label", [_vm._v("chatId：")]),
                      _c("span", [_vm._v(_vm._s(_vm.sessionInfo.chatId))]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("avue-crud", {
        ref: "crud",
        attrs: {
          option: _vm.option,
          "table-loading": _vm.loading,
          data: _vm.data,
          page: _vm.page,
        },
        on: {
          "current-change": _vm.currentChange,
          "size-change": _vm.sizeChange,
          "refresh-change": _vm.refreshChange,
        },
        scopedSlots: _vm._u([
          {
            key: "taskState",
            fn: function (scope) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.getStatusColor(scope.row.taskState),
                      size: "small",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getTaskStateText(scope.row.taskState)) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "taskType",
            fn: function (scope) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.getTaskTypeColor(scope.row.taskType),
                      size: "small",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.getTaskTypeText(scope.row.taskType)) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "executeMills",
            fn: function (scope) {
              return [
                _c("span", [_vm._v(_vm._s(scope.row.executeMills || "0"))]),
              ]
            },
          },
          {
            key: "content",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "task-content" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.content,
                          placement: "top",
                          disabled:
                            !scope.row.content ||
                            scope.row.content.length <= 50,
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.truncateText(scope.row.content, 50))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "result",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  { staticClass: "task-result" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: scope.row.result,
                          placement: "top",
                          disabled:
                            !scope.row.result || scope.row.result.length <= 50,
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.truncateText(scope.row.result, 50))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }